import { isLocalhost, teamContext, useTeamPermission } from '@vrplatform/data';
import { useContext } from 'react';

export const useCanViewAuditHistory = () => {
  const { team, teamState, membership, isVrpAdmin } = useContext(teamContext);
  const canReadAudit = useTeamPermission('audit:read', { legacy: 'teamAdmin' });

  return (
    isLocalhost &&
    isVrpAdmin &&
    teamState === 'resolved' &&
    !!team?.isGL &&
    membership?.role !== 'owner' &&
    canReadAudit
  );
};
